import { render, staticRenderFns } from "./DatesTabs.vue?vue&type=template&id=71129709&scoped=true&"
import script from "./DatesTabs.vue?vue&type=script&lang=ts&"
export * from "./DatesTabs.vue?vue&type=script&lang=ts&"
import style0 from "./DatesTabs.vue?vue&type=style&index=0&id=71129709&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71129709",
  null
  
)

export default component.exports